<template>
  <Modal
    :class="$style['dialog']"
    data-test-id="dialog"
    small
    hide-header
    hide-close
    @close="reject()">
    <template #modal-footer>
      <Btn
        ref="ok"
        tabindex="1"
        data-test-id="dialog-resolve"
        @click="resolve()">
        {{ type === 'confirm' ? $t('general/yes') : $t('general/ok') }}
      </Btn>
      <Btn
        v-if="type === 'confirm'"
        tabindex="1"
        data-test-id="dialog-reject"
        @click="reject()">
        {{ $t('general/no') }}
      </Btn>
    </template>
    <div
      v-if="message"
      v-html="message" />
  </Modal>
</template>
<script setup>
const { message, resolve, reject, type } = useDialog()
const ok = ref(null)
onMounted(() => {
  ok.value.$el.focus()
})
</script>
<style lang="scss" module>
.dialog {
  z-index: var(--z-index-dialog);
}
</style>
